import { render, staticRenderFns } from "./SitesSummaryReport.vue?vue&type=template&id=298099d4&scoped=true"
import script from "./SitesSummaryReport.vue?vue&type=script&lang=js"
export * from "./SitesSummaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298099d4",
  null
  
)

export default component.exports